import type { TeacherQueueItem, AchievementTimeFilter } from '@/types/tisa-coins';

interface Props {
  achievements: TeacherQueueItem[];
  timeFilter: AchievementTimeFilter;
  onFilterChange: (filter: AchievementTimeFilter) => void;
}

export function AchievementsSection({ achievements, timeFilter, onFilterChange }: Props) {
  const filters: AchievementTimeFilter[] = ['today', 'week', 'month', 'all'];

  return (
    <div className="bg-gray-900/50 border-2 border-emerald/30 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-cinzel font-bold text-emerald">
          ✅ Latest Achievements
        </h2>
        <div className="flex gap-2">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => onFilterChange(filter)}
              className={`px-3 py-1 rounded-lg text-xs font-bold transition-all ${
                timeFilter === filter
                  ? 'bg-emerald text-white'
                  : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
              }`}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {achievements.length === 0 ? (
        <p className="text-center text-gray-400 py-8">No achievements yet for this period</p>
      ) : (
        <div className="space-y-2 max-h-[600px] overflow-y-auto">
          {achievements.map((item) => (
            <div
              key={item.id}
              className={`bg-black/20 border rounded-lg p-3 ${
                item.action === 'approved'
                  ? 'border-emerald/20'
                  : 'border-red-500/20'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className={`text-2xl ${
                    item.action === 'approved' ? 'text-emerald' : 'text-red-500'
                  }`}>
                    {item.action === 'approved' ? '✅' : '❌'}
                  </span>
                  <div>
                    <p className="font-poppins font-bold text-white text-sm">{item.user_name}</p>
                    <p className="text-xs text-gray-400">
                      {item.type === 'quest' ? `Quest: ${item.metadata.quest_title}` : `${item.metadata.amount} coins`}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-gray-500">
                    {new Date(item.resolved_at!).toLocaleDateString()}
                  </p>
                  <p className="text-xs text-gray-600">
                    {new Date(item.resolved_at!).toLocaleTimeString()}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
